import React from 'react';
import Typography from '@mui/material/Typography';

const HSCodeColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>HS Code</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Section</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Chapter</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Product Name</Typography>
      </div>
    </>
  );
};

export default HSCodeColumns;
